export interface IDevicePositionsWithDevicesResponse {
    devices: {
        deviceId: number;
        deviceExternalId?: string;
        coordinates: {
            lat: string;
            lng: string;
            heading: number;
            speed: number;
            timestamp: string;
            satelliteCount?: number;
        }[];
    }[];
}
